import { createSlice } from "@reduxjs/toolkit";
import { ErrorType, RootState } from "../../../app/store";
import { ChargebackDetailsResponseDto, PaymentRequestDto, TransactionItemSummaryV2Dto, TransactionsSearchResponseDto, RefundActionResponseDto, TransactionItemDetailsV2Dto } from "@inosio/payments-sdk";

interface ITransDataPage {
  Rows: Array<TransactionItemSummaryV2Dto>;
}


type PMState = {
  TransactionHistory: TransactionsSearchResponseDto;
  TransDataPages: Array<ITransDataPage>;
  isRefundTrxDetailsFetching: boolean;
  isRefundTrxDetailsSuccess: boolean;
  isRefundTrxDetailsError: boolean;
  refundTrxDetailsResponse: TransactionItemDetailsV2Dto;
  refundTrxDetailsError: string | null;
  isCancelOTPSuccess: boolean;
  isCancelOTPError: boolean;
  isCancelOTPFetching: boolean;
  cancelOTPError: string | null;
  isCancelStatusFetching: boolean;
  isCancelStatusSuccess: boolean;
  isCancelStatusError: boolean;
  cancelStatusError: string | null;
  cancelStatusResponse: boolean;
  isApproveRefundSuccess: boolean;
  isApproveRefundError: boolean;
  isApproveRefundFetching: boolean;
  approveRefundResponse: RefundActionResponseDto;
  approveRefundError: string | null;
  isDenyRefundSuccess: boolean;
  isDenyRefundError: boolean;
  isDenyRefundFetching: boolean;
  isAdhocRefundFetching: boolean;
  isAdhocRefundSuccess: boolean;
  isAdhocRefundError: boolean;
  adhocRefundError: string | null;
  adhocRefundResponse: string | null;
  denyRefundResponse: string | null;
  denyRefundError: string | null;
  isCancelRefundFetching: boolean;
  isCancelRefundSuccess: boolean;
  isCancelRefundError: boolean;
  cancelRefundError: string | null;
  isSuccess: Boolean;
  isFetchingTransaction: Boolean;
  errorMessage: ErrorType
  isFetchingPaymentReqByTransUuid: boolean,
  isSuccessPaymentReqByTransUuid : boolean,
  isErrorPaymentRequestByTransUuid: string | null,
  paymentRequestDetails: PaymentRequestDto | null,
  isExportingTransDetails: boolean,
  isExportTransDetailsSuccess: boolean,
  exportTransDetailError: string,
  isFetchingChargebackDetails:boolean,
  ErrorChargebackDetails: string,
  isSuccessChargebackDetails:boolean,
  chargebackDetails: ChargebackDetailsResponseDto,
  isChangingChargebackStatus: boolean;
  isSuccessChargebackStatusChange:boolean;
  ErrorChargebackStatusChange: string;
 };

const getInitialState = () => {
  return {
    TransactionHistory: { TotalCount: 0, RecordStart: 0, RangeSize: 100, Rows: [] },
    TransDataPages: [],
    isRefundTrxDetailsFetching: false,
    isRefundTrxDetailsSuccess: false,
    isRefundTrxDetailsError: false,
    refundTrxDetailsResponse: {} as TransactionItemDetailsV2Dto,
    refundTrxDetailsError: "",
    isCancelOTPSuccess: false,
    isCancelOTPError: false,
    isCancelOTPFetching: false,
    cancelOTPError: "",
    isCancelStatusFetching: false,
    isCancelStatusSuccess: false,
    isCancelStatusError: false,
    cancelStatusError: "",
    cancelStatusResponse: false,
    isApproveRefundSuccess: false,
    isApproveRefundError: false,
    isApproveRefundFetching: false,
    approveRefundResponse: {} as RefundActionResponseDto,
    approveRefundError: "",
    isDenyRefundSuccess: false,
    isDenyRefundError: false,
    isDenyRefundFetching: false,
    denyRefundResponse: "",
    denyRefundError: "",
    isSuccess: false,
    isAdhocRefundFetching: false,
    isAdhocRefundSuccess: false,
    isAdhocRefundError: false,
    adhocRefundError: "",
    adhocRefundResponse: "",
    isCancelRefundFetching: false,
    isCancelRefundSuccess: false,
    isCancelRefundError: false,
    cancelRefundError: null,
    isFetchingTransaction: false,
    errorMessage: {} as ErrorType,
    isFetchingPaymentReqByTransUuid: false,
    isSuccessPaymentReqByTransUuid: false,
    isErrorPaymentRequestByTransUuid: null,
    paymentRequestDetails: null,
    isExportingTransDetails:false,
    isExportTransDetailsSuccess:false,
    exportTransDetailError:'',
    isFetchingChargebackDetails:false,
    ErrorChargebackDetails: '',
    isSuccessChargebackDetails:false,
    chargebackDetails:{} as ChargebackDetailsResponseDto,
    isChangingChargebackStatus: false,
    isSuccessChargebackStatusChange: false,
    ErrorChargebackStatusChange: ''
  } as PMState;
};

const pmTransactionsSlice = createSlice({
  name: "pmTransactions",
  initialState: getInitialState(),
  reducers: {
    getTransHistoryPage(state, action) {},
    getTransactionHistoryDetails(state, action) {
      state.errorMessage = {} as ErrorType;
      state.isFetchingTransaction = true;
      state.isSuccess = true;
    },
    setTransactionHistoryDetails(state, action) {
      /*
      this function has one responsiblity: receive updates from API
      and put the results in state.
      */
      let _payload = action.payload as TransactionsSearchResponseDto;

      //get a copy of the current book
      let currentTransPages = [...state.TransDataPages];

      //if startindex = 0, just reset the book because that means it's loading for the first time or he reset the range size
      if (_payload.RecordStart === 0) currentTransPages = [];

      //find out what page we are on
      let whatPageResultsIsThis = Math.ceil(_payload.RecordStart / _payload.RangeSize);

      //now, add this new data page to our book
      currentTransPages[whatPageResultsIsThis] = {
        Rows: _payload.Rows,
      };

      //return the full
      let transactionsHistoryDetailsData = {
        TransactionHistory: action.payload,
        TransDataPages: currentTransPages,
        isFetchingTransaction: false
      };

      return { ...state, ...transactionsHistoryDetailsData };
    },
    setTransactionHistoryDetailsExport(state){
      state.isFetchingTransaction=false;
    },
    setTransactionHistoryDetailError(state, action){
      state.isFetchingTransaction = false;
      state.errorMessage = action.payload
    },
    getRefundTrxDetails(state, action) {
      state.isRefundTrxDetailsFetching = true;
      state.isRefundTrxDetailsSuccess = false;
      state.isRefundTrxDetailsError = false;
      state.refundTrxDetailsError = "";
    },
    setRefundTrxDetailsResponse(state, action) {
      return { ...state, isRefundTrxDetailsFetching: false, isRefundTrxDetailsSuccess: true, refundTrxDetailsResponse: action.payload };
    },
    setRefundTrxDetailsError(state, action) {
      state.isRefundTrxDetailsFetching = false;
      state.isRefundTrxDetailsSuccess = false;
      state.isRefundTrxDetailsError = true;
      state.refundTrxDetailsError = action.payload.message;
    },
    getResetRefundTrxDetails(state) {
      state.isRefundTrxDetailsFetching = false;
      state.isRefundTrxDetailsSuccess = false;
      state.isRefundTrxDetailsError = false;
      state.refundTrxDetailsError = "";
      state.refundTrxDetailsResponse = {} as TransactionItemDetailsV2Dto;
    },
    getCancelOTP(state, action) {
      state.isCancelOTPFetching = true;
      state.isCancelOTPSuccess = false;
      state.isCancelOTPError = false;
      state.cancelOTPError = "";
    },
    setCancelOTPResponse(state, action) {
      return { ...state, isCancelOTPFetching: false, isCancelOTPSuccess: true };
    },
    setCancelOTPError(state, action) {
      state.isCancelOTPFetching = false;
      state.isCancelOTPSuccess = false;
      state.isCancelOTPError = true;
      state.cancelOTPError = action.payload.message;
    },
    getCancelStatus(state, action) {
      state.isCancelStatusFetching = true;
      state.isCancelStatusSuccess = false;
      state.isCancelStatusError = false;
      state.cancelStatusError = "";
    },
    setCancelStatusResponse(state, action) {
      return { ...state, isCancelOTPFetching: false, isCancelStatusSuccess: true, cancelStatusResponse: action.payload.canCancel };
    },
    setCancelStatusError(state, action) {
      state.isCancelStatusFetching = false;
      state.isCancelStatusSuccess = false;
      state.isCancelStatusError = true;
      state.cancelStatusError = action.payload.message;
    },
    getApproveRefund(state, action) {
      state.isApproveRefundFetching = true;
      state.isApproveRefundSuccess = false;
      state.isApproveRefundError = false;
      state.approveRefundError = "";
    },
    setApproveRefundResponse(state, action) {
      return { ...state, isApproveRefundFetching: false, isApproveRefundSuccess: true, approveRefundResponse: action.payload };
    },
    setApproveRefundError(state, action) {
      state.isApproveRefundFetching = false;
      state.isApproveRefundSuccess = false;
      state.isApproveRefundError = true;
      state.approveRefundError = action.payload.message;
    },
    getDenyRefund(state, action) {
      state.isDenyRefundFetching = true;
      state.isDenyRefundSuccess = false;
      state.isDenyRefundError = false;
      state.denyRefundError = "";
    },
    setDenyRefundResponse(state, action) {
      return { ...state, isDenyRefundFetching: false, isDenyRefundSuccess: true };
    },
    setDenyRefundError(state, action) {
      state.isDenyRefundFetching = false;
      state.isDenyRefundSuccess = false;
      state.isDenyRefundError = true;
      state.denyRefundError = action.payload.message;
    },
    getCancelRefund(state, action) {
      state.isCancelRefundFetching = true;
      state.isCancelRefundSuccess = false;
      state.isCancelRefundError = false;
      state.cancelRefundError = "";
    },
    setCancelRefundResponse(state, action) {
      return { ...state, isCancelRefundFetching: false, isCancelRefundSuccess: true };
    },
    setCancelRefundError(state, action) {
      state.isCancelRefundFetching = false;
      state.isCancelRefundSuccess = false;
      state.isCancelRefundError = true;
      state.cancelRefundError = action.payload.message;
    },
    getAdhocRefund(state, action) {
      state.isAdhocRefundFetching = true;
      state.isAdhocRefundSuccess = false;
      state.adhocRefundError = "";
    },
    setAdhocRefundResponse(state, action) {
      return { ...state, isAdhocRefundFetching: false, isAdhocRefundSuccess: true, approveRefundResponse: action.payload };
    },
    setAdhocRefundError(state, action) {
      state.isAdhocRefundFetching = false;
      state.isAdhocRefundSuccess = false;
      state.isAdhocRefundError = true;
      state.adhocRefundError = action.payload.message;
    },
    getPaymentRequestByTransUuid(state){
      state.isFetchingPaymentReqByTransUuid = true;
      state.isSuccessPaymentReqByTransUuid = false;
      state.isErrorPaymentRequestByTransUuid = '';
    },
    setPaymentRequestByTransUuid(state, action){
      state.isFetchingPaymentReqByTransUuid = false;
      state.isSuccessPaymentReqByTransUuid = true;
      state.paymentRequestDetails = action.payload;
    },
    setPaymentRequestByTransUuidError(state, action){
      state.isFetchingPaymentReqByTransUuid = false;
      state.isSuccessPaymentReqByTransUuid = false;
      state.isErrorPaymentRequestByTransUuid = action.payload.message
    },
    getExportTransDetails(state){
      state.isExportingTransDetails=true;
      state.isExportTransDetailsSuccess=false;
      state.exportTransDetailError=''
    },
    setExportTransDetails(state){
      state.isExportingTransDetails=false;
      state.isExportTransDetailsSuccess=true;
      state.exportTransDetailError=''
    },
    setExportTransDetailsError(state, action){
      state.exportTransDetailError= action.payload.message;
    },
    getChargebackDetails(state){
      state.isFetchingChargebackDetails=true;
      state.isSuccessChargebackDetails=false;
      state.ErrorChargebackDetails='';
      state.ErrorChargebackStatusChange='';
    },
    setChargebackDetails(state, action){
      state.isSuccessChargebackDetails=true;
      state.isFetchingChargebackDetails=false;
      state.ErrorChargebackDetails='';
      state.chargebackDetails=action.payload;
    },
    setChargebackDetailsError(state, action){
      state.isSuccessChargebackDetails=false;
      state.isFetchingChargebackDetails=false;
      state.ErrorChargebackDetails= action.payload.message;
    },
    getChangeChargebackStatus(state){
      state.isChangingChargebackStatus=true;
      state.isSuccessChargebackStatusChange=false;
      state.ErrorChargebackDetails='';
      state.ErrorChargebackStatusChange=''
    },
    setChangeChargebackStatus(state){
      state.isChangingChargebackStatus=false;
      state.isSuccessChargebackStatusChange=true;
      state.ErrorChargebackStatusChange=''
    },
    setErrorChangeChargebackStatus(state, action){
      state.isChangingChargebackStatus=false;
      state.isSuccessChargebackStatusChange=false;
      state.ErrorChargebackStatusChange= action.payload.message;
    }
  },
});

export const {
  getTransactionHistoryDetails,
  setTransactionHistoryDetails,
  getCancelOTP,
  setCancelOTPResponse,
  setCancelOTPError,
  getCancelStatus,
  setCancelStatusResponse,
  setCancelStatusError,
  getApproveRefund,
  setApproveRefundResponse,
  setApproveRefundError,
  getDenyRefund,
  setDenyRefundResponse,
  setDenyRefundError,
  getRefundTrxDetails,
  setRefundTrxDetailsResponse,
  setRefundTrxDetailsError,
  getAdhocRefund,
  setAdhocRefundResponse,
  setAdhocRefundError,
  getResetRefundTrxDetails,
  getCancelRefund,
  setCancelRefundResponse,
  setCancelRefundError,
  setTransactionHistoryDetailError,
  getPaymentRequestByTransUuid,
  setPaymentRequestByTransUuid,
  setPaymentRequestByTransUuidError,
  getExportTransDetails,
  setExportTransDetails,
  setExportTransDetailsError,
  setChargebackDetails,
  setChargebackDetailsError,
  getChargebackDetails,
  setChangeChargebackStatus,
  getChangeChargebackStatus,
  setErrorChangeChargebackStatus,
  setTransactionHistoryDetailsExport
} = pmTransactionsSlice.actions;

export default pmTransactionsSlice.reducer;

export const selectTransactionHistoryDetails = (state: RootState) => state.pmModuleState.TransactionHistory;
export const selectTransHistoryDetailsCurrentPage = (state: RootState) => state.pmModuleState.TransDataPages;
export const selectPMPaymentState = (state: RootState) => state.pmModuleState;
export const selectRefundTrxDetails = (state: RootState) => state.pmModuleState.refundTrxDetailsResponse;
export const selectRefundTrxDetailsFetching = (state: RootState) => state.pmModuleState.isRefundTrxDetailsFetching;
export const selectRefundResponseDetails = (state: RootState) => state.pmModuleState.approveRefundResponse;
export const selectPaymentReqByTransUuidFetching = (state: RootState) => state.pmModuleState.isFetchingPaymentReqByTransUuid;
